export const getTrayCalibrationState = (state) => state.trayCalibrationState;

export const getTrayCalibrationTrayID = (state) => state.trayCalibrationState.id;

export const getIsTrayAttached = (state) => state.trayCalibrationState.isTrayAttached;

export const getTrayCalibrationTrayType = (state) => state.trayCalibrationState.trayType;
